if (!customElements.get('nab-footer-accordion')) {
  class NabFooterAccordion extends HTMLElement {
    constructor() {
      super();
      this.is_DEV = false;
      this.triggers = this.querySelectorAll('.accordion-trigger .footer-item__title');
      this.nav = this.querySelectorAll('nav');

      this.enableMobile = this.dataset.accordionMobile === 'true';
      this.enableDesktop = this.dataset.accordionDesktop === 'true';

      if (this.is_DEV) {
        console.log('NabFooterAccordion:', {
          triggers: this.triggers,
          nav: this.nav,
          enableMobile: this.enableMobile,
          enableDesktop: this.enableDesktop
        });
      }
    }

    connectedCallback() {
      if (!this.triggers.length || !this.nav.length) return;

      this.removeAttribute('active');

      this.triggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', () => this.toggle(trigger));
      });

      this.nav.forEach(panel => panel.setAttribute('aria-visible', 'false'));

      window.addEventListener('resize', () => this.updatenav());
      this.updatenav();
    }

    toggle(trigger) {
        const isMobile = window.innerWidth < 768;
        if (!((isMobile && this.enableMobile) || (!isMobile && this.enableDesktop))) return;

        const allAccordions = document.querySelectorAll('nab-footer-accordion');

        allAccordions.forEach(accordion => {
            const triggers = accordion.querySelectorAll('.accordion-trigger');
            const nav = accordion.querySelectorAll('.accordion-panel');

            triggers.forEach((t, index) => {
                const panel = nav[index];
                if (t !== trigger) {
                    t.setAttribute('aria-expanded', 'false');
                    panel.setAttribute('aria-visible', 'false');
                    accordion.removeAttribute('active');
                }
            });
        });

        const panelIndex = Array.from(this.triggers).indexOf(trigger);
        const panel = this.nav[panelIndex];
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        trigger.setAttribute('aria-expanded', String(!isOpen));
        panel.setAttribute('aria-visible', String(!isOpen));

        if (!isOpen) {
            this.setAttribute('active', '');
        } else {
            this.removeAttribute('active');
        }
    }

    updatenav() {
      const isMobile = window.innerWidth < 768;
      const enabled = (isMobile && this.enableMobile) || (!isMobile && this.enableDesktop);
      const isActive = this.hasAttribute('active');

      this.nav.forEach(elemnt => {
        if (!enabled) {
          elemnt.setAttribute('aria-visible', 'true');
        } else {
          elemnt.setAttribute('aria-visible', String(isActive));
        }
      });
    }
  }

  customElements.define('nab-footer-accordion', NabFooterAccordion);
}
